/*global swal*/

import './style.less';
import employeeModalTemplate from 'modals/employeesSearch/index.html';
import EmployeeModalController from 'modals/employeesSearch';

export default function($log, $stateParams, $uibModal, ProfileClass, ApiClass, Swal) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;
  vm.formData = {};
  vm.submitButton = false;
  vm.loaded = false;

  const { company_id } = ProfileClass.profileComplete.profile;

  vm.submit = formData => {
    vm.submitButton = true;
    ApiClass.companiesIdTypeTypeIdPatch(
      { manage: true, id: company_id, type: 'teams', type_id: $stateParams.type_id },
      formData
    )
      .then(() => {
        _toast('Team information has been saved');
        activate();
        vm.submitButton = false;
      })
      .catch(error => {
        vm.submitButton = false;
        $log.error(error);
        throw error;
      });
  };

  vm.leader = (member, isLeader) => {
    const leaders = new Set(vm.formData.leaders);

    if (isLeader) leaders.add(member.profile_uid);
    else leaders.delete(member.profile_uid);

    ApiClass.companiesIdTypeTypeIdPatch(
      { id: company_id, manage: true, type: 'teams', type_id: $stateParams.type_id },
      { leaders: [...leaders] }
    )
      .then(() => {
        _toast('Teams leader(s) have been updated');

        vm.formData.leaders = [...leaders];
        member.leader = isLeader;
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  };

  vm.remove = member => {
    ApiClass.usersIdTypeTypeIdDelete({ id: member.profile_uid, type: 'teams', type_id: $stateParams.type_id }, null, {
      queryParams: { manage: true }
    })
      .then(() => {
        _toast('Removed member from team');
        _loadTeam(false);
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  };

  vm.selectEmployees = () => {
    const filterEmployees = vm.members.map(({ email }) => email);
    $uibModal
      .open({
        backdrop: 'static',
        animation: true,
        size: 'lg',
        template: employeeModalTemplate,
        controller: EmployeeModalController(filterEmployees),
        controllerAs: 'employeeModalCtrl'
      })
      .result.then(users => {
        vm.usersBtn = true;
        const memberIds = users.map(({ profile_uid }) => profile_uid);
        return ApiClass.usersTeamsIdPut(
          { id: $stateParams.type_id },
          { members: memberIds },
          { queryParams: { manage: true } }
        );
      })
      .then(() => {
        _toast('Added member to team');
        vm.usersBtn = false;
        _loadTeam(false);
      })
      .catch(error => {
        vm.usersBtn = false;
        if (error === 'backdrop click' || error === 'cancel') return;
        $log.error(error);
        throw error;
      });
  };

  function _toast(message) {
    Swal.toast(message);
  }

  function _isLeader(profile) {
    if (!vm.formData || !vm.formData.leaders || !vm.formData.leaders.includes(profile.profile_uid)) return;
    profile.leader = true;
  }

  function _loadTeam(updateForm = true) {
    return ApiClass.companiesIdTypeTypeIdGet({
      manage: true,
      id: company_id,
      type: 'teams',
      type_id: $stateParams.type_id
    })
      .then(({ data: { item, profiles } }) => {
        if (updateForm) vm.formData = item;
        if (vm.formData.leaders) profiles.forEach(_isLeader);
        vm.members = profiles || [];
        vm.loaded = true;
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  }

  function activate() {
    $log.debug('teams Controller Activated');
    _loadTeam();
  }
}



// WEBPACK FOOTER //
// ./src/app/controllers/admin/settings/teams/edit/index.js